import { StrictMode, useState } from 'react';
import BookingCalendar from './components/BookingCalendar';
import { StaffProvider } from './contexts/StaffContext';
import { BookingProvider } from './contexts/BookingContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import { Navigation } from '@/components/Navigation';
import { AuthGuard } from '@/components/AuthGuard';

function App() {
  const [view, setView] = useState<'daily' | 'weekly' | 'monthly' | 'quick' | 'current' | 'recurring'>('monthly');

  return (
    <StrictMode>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <AuthProvider>
          <BookingProvider>
            <StaffProvider>
              <div className="min-h-screen bg-gray-50 flex flex-col">
                <AuthGuard>
                  <Navigation view={view} onViewChange={setView} />
                  <div className="flex-1 p-4 sm:p-8">
                    <div className="max-w-[1800px] mx-auto">
                      <BookingCalendar />
                    </div>
                  </div>
                </AuthGuard>
              </div>
              <Toaster />
            </StaffProvider>
          </BookingProvider>
        </AuthProvider>
      </ThemeProvider>
    </StrictMode>
  );
}

export default App;